/**
 * `nav` namespace — Korean translations.
 *
 * Mirrors `en/nav.ts` exactly (compile-checked via `Record<NavKey, string>`).
 * Section labels follow the product glossary; the arm-state explanatory labels use
 * 실거래 활성/비활성 and 모의 실행 (the compact badges stay English in the shell).
 */
import type { NavKey } from "../en/nav";

export const nav: Record<NavKey, string> = {
  // ── rail sections ──
  dashboard: "대시보드",
  portfolio: "포트폴리오",
  market: "시장",
  strategies: "전략",
  chat: "Chat",
  orders: "주문",
  approvals: "승인",
  notifications: "알림",
  settings: "설정",

  // ── operator footer ──
  owner: "소유자",
  signOut: "로그아웃",
  setupRequired: "설정 필요",
  switchToLight: "라이트 모드로 전환",
  switchToDark: "다크 모드로 전환",
  toggleTheme: "테마 전환",

  // ── arm-state module (explanatory labels; badges stay English) ──
  tradingArmed: "실거래 활성",
  disarmed: "실거래 비활성",
  liveOrders: "새 전략 기본 · 실거래",
  dryRunSimulated: "새 전략 기본 · 모의",
} as const;
